import React, { useEffect, useRef, useState } from "react";
import Header from "./Header";
import SubHeader from "./SubHeader";
import DataTable, { formatNum } from "./DataTable";
import TableLoader from "../TableLoader";
import Apiauth from "../../../API/Apiauth";
import MetalChart from "./graph/MetalChart";
import { toFormatPrice } from "../helpers/function";

function mapRows(apiData = []) {
  return apiData.map((row) => ({
    stone_name: row.stone_name,
    qty: row.qty,
    tagPrice: row.tag_price,
    sellingPrice: row.selling_price,
    qty_sum_pct: row.qty_sum_pct,
    amount_sum_pct: row.amount_sum_pct,
  }));
}

function mapTotals(apiTotals = {}, hasData = false) {
  return {
    qty: apiTotals.qty,
    tagPrice: apiTotals.tag_price,
    sellingPrice: apiTotals.selling_price,
    qty_sum: apiTotals.qty_sum,
    amount_sum: apiTotals.amount_sum,
    qty_sum_pct: hasData ? 100 : 0,
    amount_sum_pct: hasData ? 100 : 0,
  };
}

function mapMetrics(summary = {}) {
  return [
    { label: "Stone", value: formatNum(summary.total_stones) },
    { label: "Qty", value: formatNum(summary.total_qty) },
    { label: "Total Sales Amount", value: toFormatPrice(Number(summary.total_sales || 0)) },
    { label: "Top Stone by Qty", value: summary.top_stone_by_qty ?? "-" },
  ];
}

const STONE_COLUMNS = [
  { key: "_index", label: "#", align: "center", width: 40 },
  { key: "stone_name", label: "Stone", align: "left", width: 220 },
  { key: "qty", label: "Qty", align: "right", width: 120 },
  { key: "tagPrice", label: "Tag Price", align: "right", width: 170 },
  { key: "sellingPrice", label: "Selling Price", align: "right", width: 170 },
  { key: "qty_sum_pct", label: "Qty% from over all sales", align: "right", width: 220 },
  { key: "amount_sum_pct", label: "Amount% from over all sales", align: "right", width: 250 },
];

const DEFAULT_PAGE_SIZE = 10;
const CHART_MAX_LIMIT = 100000;

const Stone = () => {
   const [rows, setRows] = useState([]);
   const [chartRows, setChartRows] = useState([]);
   const [totals, setTotals] = useState(null);
   const [metrics, setMetrics] = useState([]);
   const [filter, setFilter] = useState({});
   const [loading, setLoading] = useState(true);
   const [appliedFilters, setAppliedFilters] = useState({});
   const [totalRecords, setTotalRecords] = useState(0);
   const [page, setPage] = useState(1);
   const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
   const [showCharts, setShowCharts] = useState(false); 

  const fetchSalesByStone = ({page: p = 1,
    limit: l = pageSize,
    ...rest}={}) => {
 
     setLoading(true);
    Apiauth({ page: p, limit: l, ...rest }, "Inventory/reports/salesByStone")
      .then((res) => {
        if (res?.code === 200) {
          setRows(mapRows(res.data));
          setTotals(mapTotals(res.totals, Array.isArray(res.data) && res.data.length > 0));
          setMetrics(mapMetrics(res.summary));
         setFilter(res.filters ?? {});
         setTotalRecords(res?.pagination?.total ?? 0);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

    const fetchChartReport = (filters = {}) => {
    setLoading(true);
    Apiauth(
      { page: 1, limit: CHART_MAX_LIMIT, ...filters },
      "Inventory/reports/salesByStone"
    )
      .then((res) => {
        if (res?.code === 200) {
          setChartRows(mapRows(res.data));
        }
      })
      .finally(() => setLoading(false));
  };
    useEffect(() => {
    fetchSalesByStone({ page: 1, limit: DEFAULT_PAGE_SIZE });
  }, []);

 useEffect(() => {
    if (showCharts) {
      fetchChartReport(appliedFilters);
    }
  }, [showCharts, appliedFilters]);

  function handleFetchData({ page: newPage, limit: newLimit }) {
    if (newLimit !== pageSize) setPageSize(newLimit);
    setPage(newPage);
    fetchSalesByStone({ ...appliedFilters, page: newPage, limit: newLimit });
  }

  function handleFilterApply(filterParams = {}) {
    setAppliedFilters(filterParams);
    setPage(1);
    fetchSalesByStone({ ...filterParams, page: 1, limit: pageSize });
  }

  return (
    <>
      <Header title="Sales by Stone" metrics={metrics} />
      <SubHeader
             filters={filter} showCharts={showCharts}  setShowCharts={setShowCharts} onFilterApply={handleFilterApply}

      />
      {loading ? (
        <TableLoader />
      ) : (
          showCharts?(<MetalChart rows={chartRows} text="Stone"/>):
       ( <DataTable
          columns={STONE_COLUMNS}
          data={rows}
          totals={totals}
           showSearch={true}
          showDateRange={true}
          pageLimit={pageSize}
          totalRecords={totalRecords}
          currentPage={page}
          onPageChange={setPage}
          fetchData={handleFetchData}
        />)
      )}
    </>
  );
};

export default Stone;